document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('.survey-element-form .answer-count input[type="radio"]')
    .forEach(function (el) {
      el.addEventListener("change", function (e) {
        const params = {
          survey_element: {
            type: "Question",
            answer_count: this.value,
          },
        };
        const url = new URL(
          document
            .querySelector(".answer-count")
            .getAttribute("data-new-question-path")
        );

        Object.keys(params).forEach((key) => {
          if (typeof params[key] === "object") {
            Object.keys(params[key]).forEach((subKey) => {
              url.searchParams.append(`${key}[${subKey}]`, params[key][subKey]);
            });
          } else {
            url.searchParams.append(key, params[key]);
          }
        });

        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
            Accept: "text/html",
          },
        })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            const answers = doc.getElementsByClassName("answers")[0];
            const el = document.querySelector(".new-question .answers");
            el.innerHTML = answers.innerHTML;
          });
      });
    });

  const el = document.getElementById("survey_element_categorizer");
  if (el)
    el.addEventListener("change", function (e) {
      let disabled = e.target.checked;

      document
        .querySelectorAll(".survey_element_answers_comment input")
        .forEach(function (el) {
          el.disabled = disabled;
        });

      document
        .querySelectorAll(".survey_element_answers_custom_fields select")
        .forEach(function (el) {
          el.disabled = disabled;
        });

      document.getElementById("survey_element_weighted").disabled = disabled;
    });
});
